import React from "react";
import { Avatar } from "@mui/material";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import leftsidebarstyles from "../../../css/connect.module.css";
import { getInitials } from "../../shared/shared";

const LeftSideBarChat = ({
  channelsData,
  openChannels,
  toggleChannel,
  selectedUserId,
  handleUserClick,
}) => {
  return (
    <div className={`col-md-3 ${leftsidebarstyles.sidebar} custom-scrollBar`}>
      <div className={`${leftsidebarstyles.sidebarheader} border-bottom`}>
        <h5 className="m-0 fw-semibold text-primary">Chat Requests</h5>
      </div>

      {channelsData.map((channel) => (
        <div key={channel.name} className="mb-2">
          <div
            className={`${leftsidebarstyles.channelheader} fs-6 d-flex justify-content-between align-items-center px-3 py-2 fw-semibold text-secondary`}
            onClick={() => toggleChannel(channel.name)}
             style={{
              cursor: "pointer",
              backgroundColor: "#f7f9fc",
              borderRadius: "6px",
              margin: "4px 8px",
            }}
          >
             <span>{channel.name}</span>
            {openChannels[channel.name] ? (
              <FaChevronDown />
            ) : (
              <FaChevronRight />
            )}
          </div>
          {openChannels[channel.name] &&
            channel.groups.map((group) => (
              <div key={group.name} className="mb-2">
                <div
                  className={`${leftsidebarstyles.groupheader} text-muted px-3 py-1`}
                  style={{ fontSize: "0.85rem", letterSpacing: "0.3px" }}
                >
                  {group.name}
                </div>
                {group.users.map((user) => (
                  <div
                    key={user.id}
                    className={`${leftsidebarstyles.userlistitem} d-flex justify-content-between align-items-center px-3 py-2 rounded-2
                     ${
                      user.id === selectedUserId
                        ? `${leftsidebarstyles.active} bg-primary text-white`
                        : "hover-bg-light"
                    }
                    `}
                    onClick={() => {
                      handleUserClick(
                        user.id,
                        channel.channel_id,
                        group.name,
                        user.name,
                        user.external_id
                      );
                    }}
                      style={{ cursor: "pointer", transition: "0.2s ease-in-out" }}
                  >
                    <div className="d-flex align-items-center  gap-2">
                      <Avatar
                        src={user.profileUrl}
                        alt={user.name}
                        sx={{
                          width: 32,
                          height: 32,
                          fontSize: 14,
                          bgcolor: "#3f51b5",
                          color: "white",
                        }}
                      >
                        {getInitials(user.name)}
                      </Avatar>
                      <span className="fw-normal">{user.name}</span>
                    </div>
                    {/* {user.unread_count > 0 && (
                      <span
                        className="badge bg-danger rounded-pill"
                        style={{ fontSize: "0.7rem", minWidth: "20px" }}
                      >
                        {user.unread_count}
                      </span>
                    )} */}
                  </div>
                ))}
              </div>
            ))}
        </div>
      ))}
    </div>
  );
};

export default LeftSideBarChat;
